import {
  Button,
  DeleteIcon,
  DescriptionItem,
  DescriptionList,
} from '@billda/design-system';
import type { LabourItemDefinition } from '../api/labourItemsApi';

interface ItemDetailsPanelProps {
  item: LabourItemDefinition;
  onDelete: (item: LabourItemDefinition) => void;
}

export function ItemDetailsPanel({ item, onDelete }: ItemDetailsPanelProps) {
  return (
    <div className="flex flex-col gap-6 p-5 sm:p-6">
      <DescriptionList>
        <DescriptionItem label="Name" value={item.name} />
        <DescriptionItem
          label="Used by"
          value={
            item.groupCount === 0
              ? 'No groups'
              : `${item.groupCount} group${item.groupCount !== 1 ? 's' : ''}`
          }
        />
      </DescriptionList>

      <div className="border-t border-border-default pt-5">
        <Button
          variant="outlineDanger"
          onClick={() => onDelete(item)}
          fullWidth
          data-testid="delete-labour-item-button"
        >
          <DeleteIcon aria-hidden="true" className="size-4" />
          Delete labour item
        </Button>
      </div>
    </div>
  );
}
